"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ManufacturersReducer = undefined;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _apiManufacturer = require("../actions/esdb/apiManufacturer");

var _apiManufacturers = require("../actions/esdb/apiManufacturers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ManufacturersReducer = exports.ManufacturersReducer = function ManufacturersReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		_apiManufacturers: false
	};
	var action = arguments[1];

	switch (action.type) {
		case _apiManufacturer.API_MANUFACTURER_REQUEST:
			return _lodash2.default.merge({}, state, _defineProperty({}, action.options.MANUFACTURER_ID, action.payload));

		case _apiManufacturer.API_MANUFACTURER_SUCCESS:
			return _lodash2.default.merge({}, state, action.payload.data.reduce(function (obj, item) {
				obj[item.MANUFACTURER_ID] = {
					loading: action.payload.loading,
					error: action.payload.error,
					data: item
				};
				return obj;
			}, {}));

		case _apiManufacturers.API_MANUFACTURERS_SUCCESS:
			state = _lodash2.default.merge({}, state, {
				_apiManufacturers: true
			});
			return _lodash2.default.merge({}, state, action.payload.data.reduce(function (obj, item) {
				obj[item.MANUFACTURER_ID] = {
					loading: action.payload.loading,
					error: action.payload.error,
					data: item
				};
				return obj;
			}, {}));

		default:
			return state;
	}
};